import React, { memo, useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import DoneButton from '../atoms/DoneButton';
import { KWANKGM11010A01 } from '../const/api_modules';
import { fileDownload } from '../FileDownload';
import { content_type } from '../Const';
import { RequestDetail } from '../types/CoomonApiDetail';

interface Props {
  requestCommonApi: (
    module_name: string,
    is_json: boolean,
    is_blob: boolean,
    details: RequestDetail[]
  ) => Promise<any>;
  is_csv_downloaded: boolean;
}

// KWANKGM10040_案件詳細（職員）
const FooterStaffDetails: React.FC<Props> = ({ requestCommonApi, is_csv_downloaded }) => {
  const [modal_csv_download, setModalCsvDownload] = useState(false);
  const [modal_error_message, setModalErrorMessage] = useState(false);
  const [error_message, setErrorMessage] = useState('');

  const [is_download_done, setIsDownloadDone] = useState(false); // ダウンロード済か否か

  // 「案件一覧へ戻る」ボタンクリック時のアクション
  const handleClickReturn = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;
  };

  /**
   * ダウンロード確認ポップアップの「OK」ボタンをクリックする
   * @returns void
   */
  const handleClickDownloadConfirm = () => {
    setModalCsvDownload(false);
    requestCommonApi(KWANKGM11010A01, false, true, [])
      .then(res => {
        // ファイルのダウンロードを実行する
        fileDownload(res.data, res.headers['content-disposition'], content_type.csv);
        setIsDownloadDone(true);
      })
      .catch(error => {
        setErrorMessage('システムエラーが発生しました');
        setModalErrorMessage(true);
      });
  };

  return (
    <>
      <Row className="my-5">
        <Col xl={{ span: 2, offset: 3 }} lg={6} md={6} sm={12} xs={12} className="text-center">
          <a
            className="btn btn-bg-white btn-outline-success btn-text-color btn-system"
            onClick={handleClickReturn}
          >
            案件一覧へ戻る
          </a>
        </Col>
        <Col xl={{ span: 2, offset: 2 }} lg={6} md={6} sm={12} xs={12} className="text-center">
          <DoneButton
            label="ダウンロード"
            handleClick={() => setModalCsvDownload(true)}
            is_done={is_csv_downloaded || is_download_done}
            className="btn-text-color"
          />
        </Col>
      </Row>
      {/* CSVダウンロード確認ポップアップ */}
      <Modal
        show={modal_csv_download}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>CSVデータのダウンロードを開始します。よろしいですか？</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-outline-success btn-text-color"
            onClick={() => setModalCsvDownload(false)}
          >
            キャンセル
          </a>
          <a className="btn btn-main-color" onClick={handleClickDownloadConfirm}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
      {/* エラー表示 */}
      <Modal
        show={modal_error_message}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>{error_message}</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-main-color" onClick={() => setModalErrorMessage(false)}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(FooterStaffDetails);
